import { useEffect, useRef, useState } from "react";

const DESKTOP_WIDTH = 1440;
const DESKTOP_HEIGHT = 800;

/** The containing button owns all interaction; the document is display-only. */
export function InertHtmlCardPreview({ html, title }: { html: string; title: string }) {
  const hostRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(0);
  const [state, setState] = useState<"loading" | "ready" | "failed">("loading");
  useEffect(() => {
    setState("loading");
    const timeout = window.setTimeout(() => setState(current => current === "loading" ? "failed" : current), 15000);
    return () => window.clearTimeout(timeout);
  }, [html]);
  useEffect(() => {
    const host = hostRef.current;
    if (!host) return;
    const measure = () => setWidth(host.getBoundingClientRect().width);
    measure();
    if (typeof ResizeObserver === "undefined") {
      window.addEventListener("resize", measure);
      return () => window.removeEventListener("resize", measure);
    }
    const observer = new ResizeObserver(measure);
    observer.observe(host);
    return () => observer.disconnect();
  }, []);
  return <div ref={hostRef} className="absolute inset-0 overflow-hidden bg-white" aria-hidden="true">
    <iframe key={html} title={title} srcDoc={html} sandbox="" referrerPolicy="no-referrer"
      tabIndex={-1} className="pointer-events-none absolute left-0 top-0 block max-w-none origin-top-left border-0 bg-white"
      style={{ width: DESKTOP_WIDTH, height: DESKTOP_HEIGHT, transform: `scale(${width / DESKTOP_WIDTH})`, visibility: state === "ready" ? "visible" : "hidden" }}
      onLoad={() => setState("ready")} onError={() => setState("failed")} />
    {state !== "ready" && <div className="absolute inset-0 grid place-items-center bg-muted p-2 text-center text-[10px] text-muted-foreground">
      {state === "loading" ? "Loading preview…" : "Preview unavailable"}
    </div>}
  </div>;
}
